import React, { FC } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import { Button, Video, PopUpCloseIcon, PopUpVideo } from 'styled';

import useLanguage from 'hooks/useLanguage';
import { Video as IVideo, GlobalState } from 'types';

interface StoreProps {
  video: IVideo | null;
}

type Props = {
  popUpIsActive: boolean;
  closePopUp(): void;
  pageHasMinimalNav?: boolean;
} & StoreProps;

const VideoPopUp: FC<Props> = ({
  video,
  popUpIsActive,
  closePopUp,
  pageHasMinimalNav,
}) => {
  const Language = useLanguage();

  if (!video || !popUpIsActive) {
    return null;
  }

  return (
    <div
      className={cx(
        'VideoPopUp fixed t0 w100 h100 z-pop-up flex items-center justify-center bg-color-blue-80',
        {
          'transition-fade-in': popUpIsActive,
          'transition-fade-out events-none': !popUpIsActive,
          'hidden opacity-0 events-none': !popUpIsActive,
          'VideoPopUp__with-minimal-nav': pageHasMinimalNav,
        }
      )}
    >
      <div
        className="VideoPopUp__bg absolute t0 b0 r0 l0 bg-color-blue-80 transition-short w100 h100"
        onClick={closePopUp}
      />
      <div className="VideoPopUp__container relative z-1 w100 h100 bg-color-white md:my1_5">
        <div className="VideoPopUp__top-bar flex items-center relative">
          <p className="text-md md:text-lg p1_5">{video.title}</p>
          <Button
            ariaLabel={Language.t('Global.closePopUp')}
            containerClassName="absolute t0 r0 p1_5 md:p2"
            onClick={closePopUp}
          >
            <PopUpCloseIcon />
          </Button>
        </div>
        <div className="flex-grow">
          <PopUpVideo as={Video} video={video} showVimeoVideoControl autoPlay />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: GlobalState): StoreProps => ({
  video: state.showcasePage.activeVideo,
});

export default connect(mapStateToProps)(VideoPopUp);
